// extracted by mini-css-extract-plugin
export default {"button":"OfflineDownload_button__44uP2","done":"OfflineDownload_done__Fi6tJ"};